import * as next from 'next'

import * as hooks from '@owl-nest/hooks'
import * as services from '@owl-nest/services'

import * as core from '@boutique/services'
import * as entities from '@boutique/entities'
import * as contentful from '@boutique/contentful'

import { type GiftIdeasProps, HITS_PER_GITFIDEAS_PAGE } from '@boutique/product'
export { GiftIdeas as default } from '@boutique/product'

export async function getServerSideProps(
  context: next.GetServerSidePropsContext,
): Promise<next.GetServerSidePropsResult<GiftIdeasProps>> {
  const query = entities.search.giftIdea.fromParsedUrlQuery(context.query)
  const preFetchedData = await core.search.giftIdea.searchGiftIdea({
    ...query,
    hitsPerPage: HITS_PER_GITFIDEAS_PAGE,
  })

  const preFetchFooter = await services.footer.listForFooter('fr', contentful.request)
  const footerCache: services.footer.Cache = {}
  preFetchFooter.next((success) => {
    footerCache[services.footer.id({ locale: 'fr' })] = { status: hooks.QueryStatus.SUCCESS, data: success }
  })

  return {
    props: {
      productCache: {
        [core.search.giftIdea.id(query)]: {
          status: hooks.QueryStatus.SUCCESS,
          data: preFetchedData,
        },
      },
      footerCache,
    },
  }
}
